import './Welcome.css'; // CSS

function Welcome({howToBuy, onClose}) {
    return (
        <div className="welcome" onClick={onClose}>
            <div className="welcome__inner" onClick={(e) => e.stopPropagation()}>
                <div className="welcome__header">
                    {howToBuy? (
                        <h1 className="welcome__title">Siga os passos abaixo para comprar</h1>
                    ) : (
                        <>
                            <h1 className="welcome__title">Olá, seja bem vindo!</h1>
                            <h2 className="welcome__subtitle">Siga os passos abaixo para comprar</h2>
                        </>
                    )}
                </div>

                <div className="welcome__line"></div>
                
                <div className="welcome__steps">
                    <div className="welcome__step">
                        <span className="welcome__step-number">1</span>
                        <span className="welcome__step-text">
                            Toque ou clique em um ovo para mais detalhes.
                        </span>
                    </div>

                    <div className="welcome__step">
                        <span className="welcome__step-number">2</span>
                        <span className="welcome__step-text">
                            Escolha as opções do seu ovo e adicione na sacola. Adicione quantos ovos quiser.
                        </span>
                    </div>

                    <div className="welcome__step">
                        <span className="welcome__step-number">3</span>
                        <span className="welcome__step-text">
                            Vá para a sacola, confira seu pedido, escolha a forma de pagamento e toque ou clique em "Finalizar pedido".
                        </span>
                    </div>
                </div>

                <div className="welcome__footer" onClick={onClose}>
                    <span className="orange-button-light">Fechar</span>
                </div>
            </div>
        </div>
    );
}

export default Welcome;